<template>
	<div class="share">
		<title>{{check?'绑定新账号':'修改绑定账号'}}</title>
		<div>
			<span>当前绑定的手机号：<span>{{user.phone}}</span></span>
			<div v-if="!check">
				<mt-field type="tel" placeholder="验证码" v-model="form.oldCode">
					<span @click="getcode">获取验证码</span>
				</mt-field>
			</div>
			<div v-if="check">
				<mt-field type="tel" placeholder="请输入要绑定的新手机号" v-model="form.phone"></mt-field>
			</div>
			<div v-if="check">
				<mt-field type="tel" placeholder="验证码" v-model="form.code">
					<span @click="getcode">获取验证码</span>
				</mt-field>
			</div>
			<div>
				<mt-button @click.native="next" type="default" style="width: 100%;color:#fff;background:#4389F2;">{{check?'下一步':'确定'}}</mt-button>
			</div>
		</div>
	</div>
</template>
<script>
	import { Field,Button,Toast } from 'mint-ui';
	export default {
		computed: {
			
		},
		data() {
			return {
				user:{},
				check:false,//第一步验证
				form:{}
			}
		},
		methods: {
			getcode(){
				if(this.form.phone && this.form.phone.length==11 || !this.check){
					this.$store.dispatch('post',{u:'/wx/send_to_code',d:{phone:this.check?this.form.phone:this.user.phone}}).then(function(res){
				    	if(res.err==0 || res.err==1){
				    		Toast({
								message: '发送成功，请输入验证码！',
								iconClass: 'iconfont icon-gou'
							});
							return
				    	}
				    	Toast({
							message: res.data,
						});
					})
				}else{
					Toast({
						message:'请正确输入手机号',
					});
				}
			},
			next() {
				let self=this
				if(self.check){
					if(!self.form.code){
						return Toast({
							message: '请输入正确的验证码！',
						});
					}
					let form=self.form
					form.oldUserId=self.user.id
					self.$store.dispatch('post',{u:'/wx/new_phone',d:form}).then(function(res){
				    	if(res.err==0){
				    		Toast({
								message: '修改成功！',
								iconClass: 'iconfont icon-gou'
							});
				    		self.$router.push({name:'share'});
							return
				    	}
				    	Toast({
							message: res.data,
						});
					})
				}else{
					if(!self.form.oldCode){
						return Toast({
							message: '请输入正确的验证码！',
						});
					}
					self.$store.dispatch('post',{u:'/sms_code/check',d:{phone:self.user.phone,code:self.form.oldCode}}).then(function(res){
				    	if(res.err==0){
				    		self.check=true
							return
				    	}
				    	Toast({
							message: res.data,
						});
					})
				}
			},
		},
		mounted() {
			let self=this
			self.$store.dispatch('post',{u:'/wx/query_open_id',d:{wx_open_id:localStorage.openid}}).then(function(res){
		    	if(res.err==0){
		    		self.user=res.data
		    		let go=window.location.protocol+'//'+window.location.host+'/wxprior/'+res.data.id
		    		//初始化微信分享
		    		wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
						wx.updateAppMessageShareData({ 
							title:'赢200元优惠券，免费拿走智能锁',
							desc:'参与活动，赢200元优惠券，免费拿走智能锁',
							link:go,
							imgUrl: 'https://xhlzn.oss-cn-hangzhou.aliyuncs.com/share.jpg',
						}, function(res) {
							
						});
						wx.updateTimelineShareData({ 
							title:'赢200元优惠券，免费拿走智能锁',
							link:go,
							imgUrl: 'https://wx.hooply.net/icon.jpg',
						}, function(res) {
							
						});
						wx.onMenuShareAppMessage({
							title:'赢200元优惠券，免费拿走智能锁',
							desc:'参与活动，赢200元优惠券，免费拿走智能锁',
							link:go,
							imgUrl: 'https://xhlzn.oss-cn-hangzhou.aliyuncs.com/share.jpg',
							type: '', 
							dataUrl: '', 
							success: function () {
							// 用户点击了分享后执行的回调函数
							}
						});
						wx.onMenuShareTimeline({
							title:'赢200元优惠券，免费拿走智能锁',
							link:go,
							imgUrl: 'https://wx.hooply.net/icon.jpg',
							success: function () {
							// 用户点击了分享后执行的回调函数
							},
						});
					});
					return
		    	}
		    	self.$router.push({name:'share'});
			})
		}
	}
</script>
<style scoped>
	.share{
		width: 100vw;
		height: 100%;
		min-height: 100vh;
	}
	.share>div{
		width:92vw;
		margin: 0 auto;
		padding:4vw;
		text-align: center;
	}
	.share>div>span{
		line-height: 30px;
		font-weight: bold;
	}
	.share>div>span>span{
		color:#4389F2;
	}
	.share>div>div{
		margin-top: 10px;
		border-bottom:1px solid #B3B3B3;
	}
	.share>div>div span{
		color: #4389F2;
	}
	.share>div>div:last-child{
		margin-top: 54px;
		border-bottom:none;
	}
</style>


// WEBPACK FOOTER //
// src/views/shareUser.vue